import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { ImagilityBaseResponse } from '../../data/models/response.model';
import { BehaviorSubject, Subject, Observable, of, EMPTY } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class RecipientsService {

  constructor(private httpClient:HttpClient) { }

  private saveGroupSubject = new Subject<boolean>();
  saveGroupObservable = this.saveGroupSubject.asObservable();

  saveGroup(){
    return this.saveGroupSubject.next(true); 
  }

  getCompanyList(companyId){
   return this.httpClient.get(`/reportwriter/company/${companyId}/companyList`).pipe(
    map((response: ImagilityBaseResponse) => {
      if (response.status) {
        return response;
      }
    })
  );  
  }

  getRecipientGroupList(payload){
    return this.httpClient.post(`/reportwriter/company/${payload.companyId}/groupList`,payload).pipe(
      map((response: ImagilityBaseResponse) => {
        if (response.status) {
          return response.data;
        }
      })
    );  
  }

  getRecipientList(companyId){
    return this.httpClient.get(`/reportwriter/company/${companyId}/recipientList`).pipe(
      map((response: ImagilityBaseResponse) => {
        if (response.status) {
          return response;
        }
      })
    ); 
  }

  saveRecipientGroup(payload,companyId){
    return this.httpClient.post(`/reportwriter/company/${companyId}`,payload).pipe(
      map((response: ImagilityBaseResponse) => {
        if (response.status) {
          return response;
        }
      })
    ); 
  }

  deleteRecipientGroup(companyId,groupId){
    return this.httpClient.delete(`/reportwriter/company/${companyId}/group/${groupId}`).pipe(
      map((response: ImagilityBaseResponse) => {
        if (response.status) {
          return response;
        }
      })
    ); 
  }

  getRecipientGroup(companyId,groupId){//
    return this.httpClient.get(`/reportwriter/company/${companyId}/group/${groupId}/recipientList`).pipe(
      map((response: ImagilityBaseResponse) => {
        if (response.status) {
          return response;
        }
      })
    );
  }
}
